<template>
  <div class="SigninDetails">
    <div  @click="closeDialog">
      <div class="closeIcon iconfont icon-icon_wrong"></div>
      <div class="head_title">签到情况如下：</div>
      <div class="class_name">
        {{ classNameSet && classNameSet.join("，") }}
      </div>
    </div>
    <van-tabs
      v-model="active"
      background="#f7f7f7"
      color="#D91818"
      title-inactive-color="#999999"
      title-active-color="#333333"
    >
      <van-tab
        :title="getTitle(keyName, val)"
        v-for="(val, keyName, index) in stuList"
        :key="index"
      >
        <div class="tab_content" v-if="val.length > 0">
          <div v-for="(student, i) in val" class="name_item" :key="i">
            {{ student.name || "" }}
          </div>
        </div>
        <div class="tab_content_empty bootscreen-emptydiv" v-else>
          <div class="emptydiv-imgdiv">
            <img class="emptydiv-img" src="../../../../../public/img/product/bootScreen/img-zwqdxx.png" alt="">
          </div>
          <div class="emptydiv-text">暂无数据</div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
  props: {
    //所有学员的考勤情况
    stuList: {
      type: Object,
      default: ()=>{},
    },
    //当前所有班次
    classNameSet: {
      type: Array,
      default: ()=>[],
    },
  },
  methods: {
    closeDialog() {
      this.$parent.$parent.DetailsDialog = false;
    },
    getTitle(key, val) {
      var tar = "";
      switch (key) {
        case "notSignList":
          tar = "未签到";
          break;
        case "signList":
          tar = "出勤";
          break;
        case "leaveList":
          tar = "请假";
          break;
        case "shouldSignList":
          tar = "应到";
          break;
        default:
          break;
      }
      tar += " " + val.length;
      return tar;
    },
  },
};
</script>

<style>
</style>